import React, { useEffect, useState } from "react";
import { useCustomContext } from "../../../state/CustomContext";
import { callAPIForQuery } from "../../../utilities/service";
import { cloneDeep } from "lodash";
import { useNavigate, useSearchParams } from "react-router-dom";

const BranchCreate = () => {
    const context = useCustomContext();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { state } = context;

    const userId = state?.user_id || "";
    const [tenants, setTenants] = useState([]);
    const [hospitals, setHospitals] = useState([]);

    interface BranchFormData {
        code: string;
        name: string;
        contact_no: string;
        email_id: string;
        address: string;
        pincode: string;
        tenant_id: string;
        hospital_id: string;
        isactive: string;
    }

    const [formData, setFormData] = useState<any>({
        id: -1,
        code: "",
        name: "",
        contact_no: "",
        email_id: "",
        address: "",
        pincode: "",
        tenant_id: "",
        hospital_id: "",
        isactive: "1",
        created_by: userId
    });


    const [errors, setErrors] = useState<any>({
        code: "",
        name: "",
        contact_no: "",
        email_id: "",
        address: "",
        pincode: "",
        tenant_id: "",
        hospital_id: "",
    });

    useEffect(() => {
        loadTenants();
        loadHospitals();
        const id = searchParams.get("id");
        if (id)
            getBranch(Number(id));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const getBranch = async (id: number) => {
        const response = await callAPIForQuery({ input: JSON.stringify({ id: id }), type: "get_branch" }, "post")
        const formDataCopy: any = cloneDeep(formData);
        if (response?.[0]?.[0]) {

            Object.keys(response[0][0]).forEach((key: string) => {
                if (formData[key] !== null && formData[key] !== undefined)
                    formDataCopy[key] = response[0][0][key]
            });
            setFormData(formDataCopy)
        } else {
            alert('Invalid request. Please contact your administrator');
        }
    }
    const loadTenants = async () => {
        const response = await callAPIForQuery({ input: JSON.stringify({ id: '%' }), type: "get_tenant" }, "post");
        setTenants(response[0] || []);
    };

    const loadHospitals = async () => {
        const response = await callAPIForQuery({ input: JSON.stringify({}), type: "get_hospital" }, "post");
        setHospitals(response[0] || []);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData((prev: any) => ({
            ...prev,
            [name as keyof BranchFormData]: value,
        }));
    };


    const validateForm = () => {
        let valid = true;
        let newErrors = { code: "", name: "", contact_no: "", email_id: "", address: "", pincode: "", tenant_id: "", hospital_id: "" };

        Object.keys(newErrors).forEach((key) => {
            if (!formData[key as keyof typeof formData].toString().trim()) {
                newErrors[key as keyof typeof newErrors] = `${key.replace("_", " ")} is required`;
                valid = false;
            }
        });

        setErrors(newErrors);
        return valid;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        try {
            const response = await callAPIForQuery({ input: JSON.stringify(formData), type: "insert_update_branch" }, "post");
            if (response.error) {
                alert("Some Error occurred");
            } else {
                alert("Saved Branch successfully");
                navigate('/branch-view')
            }
        } catch (error) {
            console.error("Error saving branch:", error);
            alert("Failed to save branch.");
        }
    };

    return (
        <>
         <div className="module-title">Branch Creation</div>
            <div className="row">
                {Object.keys(formData).map((key) => (
                    key !== "created_by" && key !== "id" && (
                        <div className="form-option col-lg-3 mb-3" key={key}>
                            <label className="field-title">{key.replace("_", " ").toUpperCase()}</label>
                            {key === "tenant_id" || key === "hospital_id" || key === "isactive" ? (
                                <select name={key} value={formData[key]} onChange={handleChange} className="form-control">
                                    <option value="">--Select--</option>
                                    {key === "tenant_id" && tenants.map((opt: any) => <option key={opt.id} value={opt.id}>{opt.name}</option>)}
                                    {key === "hospital_id" && hospitals.map((opt: any) => <option key={opt.id} value={opt.id}>{opt.hospital_name}</option>)}
                                    {key === "isactive" && (<><option value="1">Yes</option><option value="0">No</option></>)}
                                </select>
                            ) : (
                                <input type="text" name={key} value={formData[key]} onChange={handleChange} className="form-control" />
                            )}
                            {errors[key] && <p className="text-danger">{errors[key]}</p>}
                        </div>
                    )
                ))}
            </div>
            <div className="action-set">
                <div>
                    <input onClick={handleSubmit} type="button" className="form-control" value={formData.id > 0 ? "Update" : "Save"} />
                </div>
            </div>
        </>
    );
};

export default BranchCreate;
